import React from 'react';
import { FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-white text-black py-6">
      <div className="flex flex-col items-center justify-center space-y-2">
        <div className="flex space-x-4 text-2xl">
          {/* Social icons, e.g. Instagram */}
          <a
            href="https://instagram.com/meloryjasmin"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-black-400"
          >
	    <FaInstagram />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

